import { createSlice } from "@reduxjs/toolkit";

const roleState = {
  roledata: {}
}

const roleSlice = createSlice({
  name: 'roles',
  initialState: roleState,
  reducers: {
    storeDataRole: (state, action) => action.payload,
  }
})

export const { storeDataRole } = roleSlice.actions;
export default roleSlice.reducer;